module.exports = __webpack_public_path__ + "img/uk.db68882c.svg";